export default "/_next/static/images/service-maxbone-desktop@3x-1668e6b2c58e9bf85e01c0f1fad52750.jpg";